import { render, staticRenderFns } from "./UserSentences.vue?vue&type=template&id=9ec54ed8&scoped=true"
import script from "./UserSentences.vue?vue&type=script&lang=js"
export * from "./UserSentences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec54ed8",
  null
  
)

export default component.exports